
// 判断是开发还是生产
let env = process.env.NODE_ENV === 'development' ;  

export default {
    // 新华社正式
    base_1: env ? '/fta':'https://en.imsilkroad.com/fta',             // 接口域名
    base_3: env ? '/newFta':'https://en.imsilkroad.com',              // 新闻列表 （新华社提供） https://en.imsilkroad.com
    base_2: env ? '/newZFta':'https://recommend.imsilkroad.com', 
    // 新华社测试
    // base_1: env ? '/fta':'http://envue.xhsl.xhszjs.cn/xhsl',             
    // base_3: env ? '/newFta':'http://envue.xhsl.xhszjs.cn/api',              
    // 百分点测试
    // base_1: env ? '/fta':'http://172.26.11.91:30002/xhsl',             
    // base_3: env ? '/newFta':'http://172.26.11.91:30002/api',              
    // base_2: env ? '/newZFta':'http://172.26.11.91:30002/recommend',              
}

